"use strict";
var CustomerViewModel = (function () {
    function CustomerViewModel() {
    }
    return CustomerViewModel;
}());
exports.CustomerViewModel = CustomerViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/customer-view.model.js